
export default {
  path: '/hulk',
  name: 'hulk',
  component: () => import('@/views/Page.vue'),
  children: [
    {
      path: 'list',
      component: () => import('@/components/hulk/List.vue'),
      meta: {
        title: 'HULK审批'
      }
    },
    {
      path: 'upcoming/details',
      component: () => import('@/components/hulk/Details.vue'),
      meta: {
        title: '审批详情'
      }
    },
    {
      path: 'completed/details',
      component: () => import('@/components/hulk/DoneDetails.vue')
    }
  ]
}
